import { useState } from 'react';
import './Accordion.css';

export default function Accordion({ title, children, defaultOpen = false, accent = null }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`accordion${open ? ' accordion--open' : ''}`}>
      <button
        type="button"
        className="accordion-trigger"
        aria-expanded={open}
        onClick={() => setOpen(o => !o)}
      >
        {accent && (
          <span className={`accordion-accent accordion-accent--${accent}`} aria-hidden="true" />
        )}
        <span className="accordion-title">{title}</span>
        <span className="accordion-chevron" aria-hidden="true" />
      </button>

      <div className="accordion-body">
        <div className="accordion-body-inner">
          <div className="accordion-content">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
